import AppsAnalytics from '../analytics/AppsAnalytics';

export function clientTokenExpiryCheck() {
	const isUserTokenValid = typeof window.adobeIMS !== 'undefined' && typeof window.adobeIMS.isSignedInUser() !== 'undefined';
	if (!isUserTokenValid) {
		const appsAnalytics = new AppsAnalytics(window.ENV);
		appsAnalytics.initAnalytics();
		const reloadPage = () => window.location.href = window.location.href;
		const tokenIngestPromise = appsAnalytics.onCCHTokenCheck(false);
		if (tokenIngestPromise) {
			tokenIngestPromise.then(reloadPage)
				.catch(reloadPage);
		}
	}
	return isUserTokenValid;
}